// tslint:disable:max-line-length

import React from 'react';

export const ChartPie = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M7.5,0C3.5,0.3,0.3,3.5,0,7.5h7.5V0z" />
      <path d="M8.5,0v8.5H0C0.3,12.7,3.8,16,8,16c4.4,0,8-3.6,8-8C16,3.8,12.7,0.3,8.5,0z" />
    </svg>
  );
};
